import React, { useEffect, useState } from 'react'
import { getWhatsAppInfo } from 'src/config/api'
import styled, { withTheme } from 'styled-components'
// import Intl from "src/components/common/Intl";
// import WhatsappAni from './icon/WhatsappAni';
import cookieUtil from 'src/util/cookieUtil';
import { ECookieName } from 'src/util/utilModel';
// import { Player } from '@lottiefiles/react-lottie-player';
import config from 'src/config/config';
import { withAppContext } from 'src/store/initAppContext';
import { Player } from '@lottiefiles/react-lottie-player';
import Intl from './common/Intl';
import { CRMWhatsappClick } from 'src/util/crmUtil';
import chat100 from 'src/util/chat100';

type WhatsAppDataInterface = {
    phoneNumber: string,
    type: string,
    message: string,
    memo: string
}

type StyleProps = {
    rightSpace: string
}

export const clubsitePixel = (brandID, isprev = false, isLead = false,) => {
    const _location = typeof window === 'object' ? window.location : null;
    const _search = _location && _location.pathname === "/" && _location.search;
    const marketingSource = (_search || ' ').split('?marketingSource=')[1]
    if (marketingSource && (brandID === 32)) {
        if (marketingSource === "channel354") {
            import("react-facebook-pixel")
                .then((x) => x.default)
                .then((ReactPixel) => {
                    ReactPixel.init("537461558078361", null, {
                        autoConfig: true,
                        debug: false,
                    });
                    if (isprev) {
                        ReactPixel.pageView();
                        //ReactPixel.track("Lead", "");
                    } 
                    if (isLead) {
                        ReactPixel.track("Lead", "");
                    }
                });
        }
    }

    //for CRM
   // CRMWhatsappClick(brandID)
}

const WhatsAppBeforeLoginComp = (props) => {
    const [whatsAppData, setWhatsAppData] = useState({} as WhatsAppDataInterface)
    const isAuth = cookieUtil.get(ECookieName.COOKIE_TOKEN);
    const { app: { brandId } } = props;
    const [showIcon, setShowIcon] = useState(false);
    const [openChat, setOpenChat] = useState(false)

    const { config: { chat100SiteId, chat100IdBeforeLogin, showChat100Provider } } = props.theme;

    useEffect(() => {
        showWhatsAppIco()
        //fetchWhatsAppInfo();
        //pixel page View
        clubsitePixel(brandId, true)
    }, []);

    // const fetchWhatsAppInfo = () => {
    //     getWhatsAppInfo(brandId).then((res) => {
    //         const { data = {} } = res.data || {}
    //         setWhatsAppData(data)
    //     }).catch((err) => {
    //         console.error(err)
    //     })
    // }

    const showWhatsAppIco = () => {
        const API = `${config.agentwhatsappAPI}/default/get-agent-whatsapp-api?brand_id=${brandId}`
        fetch(API).then(res => res.json()).then(res => {
            const { is_enabled } = res || {};

            const hasWhatsappRotation = typeof res.is_whatsapp_rotation !== 'undefined';

            setShowIcon(is_enabled);
            //Here, I am adding a check to implement the chat feature on this icon.
            if (hasWhatsappRotation) {
                const chatstate = is_enabled && !res.is_whatsapp_rotation;
                setOpenChat(chatstate)
            }

        }).catch(err => console.error(`getAgentWhatsappApi: ${err}`))
    }


    //Adding some changes in current functionality
    const fetchWhatsAppInfo = (callback?: any) => {
        if (whatsAppData.phoneNumber) {
            let link = `https://wa.me/${(whatsAppData.phoneNumber || "").trim()}?text=${whatsAppData.message}`;
            window.location.href = link;
            if (callback && typeof callback == 'function') {
                callback();
            }
        }
        else {
            getWhatsAppInfo(brandId).then((res) => {
                const { data = {} } = res.data || {}
                setWhatsAppData(data);
                let link = `https://wa.me/${(data.phoneNumber || "").trim()}?text=${data.message}`;
                window.location.href = link;
                if (callback && typeof callback == 'function') {
                    callback();
                }
            }).catch((err) => {
                console.error(err)
            })
        }
    }

    const openChatBot = async () => {
        if (!showChat100Provider) return;

        const chat100Data = {
            siteId: chat100SiteId,
            codePlan: chat100IdBeforeLogin
        };

        try {
            await chat100.open(chat100Data);
        } catch (error: any) {
            console.error("Chat100 open failed:", error);
        };
    }

    const imgSrc = '/static/cashsite/brand/6/icon/whatsappOnlyOnce.gif';

    if (showIcon && openChat) {
        return (<WhatsAppNewWrapper id="WhatsappIcoWrapper">
            {!isAuth && (
                <span onClick={openChatBot} title="Get an ID instantly">
                    <img className='whatsAppImg' src={`${config.imageV3NonOptHost}${imgSrc}`} alt="Get an ID instantly" />
                </span>)
            }
        </WhatsAppNewWrapper>)
    }
    else if (showIcon) {
        return (
            <WhatsAppNewWrapper id="WhatsappIcoWrapper">
                {!isAuth && (
                    <span onClick={() => fetchWhatsAppInfo(() => clubsitePixel(brandId, false, true))} title="Get an ID instantly">
                        <img className='whatsAppImg' src={`${config.imageV3NonOptHost}${imgSrc}`} alt="Get an ID instantly" />
                    </span>)
                }
            </WhatsAppNewWrapper>
        )
    }

    return null
}

export const WhatsAppBeforeLogin  = withTheme(withAppContext(WhatsAppBeforeLoginComp));


function WhatsappIco(props) {
    const { app: { brandId, token }, theme } = props;
    const { showWhatsAppAfterLogin, showWhatsAppBeforeLogin, showChat100Provider, chat100SiteId, chat100IdBeforeLogin } = theme.config;
    const [openChat, setOpenChat] = useState(false)

    const [whatsAppData, setWhatsAppData] = useState({} as WhatsAppDataInterface)
    const isAuth = cookieUtil.get(ECookieName.COOKIE_TOKEN);
    const [tooltipState, setTooltipState] = useState(true);
    const [showIcon, setShowIcon] = useState(false);

    useEffect(() => {
        //fetchWhatsAppInfo();
        showWhatsAppIco()
    }, [])

    // //fetching whatsapp details
    // const fetchWhatsAppInfo = () => {
    //     getWhatsAppInfo(brandId).then((res) => {
    //         const { data = {} } = res.data || {};
    //         setWhatsAppData(data)
    //     }).catch((err) => {
    //         console.error(err)
    //     })
    // }


    const showWhatsAppIco = async () => {
        try {
            const API = `${config.agentwhatsappAPI}/default/get-agent-whatsapp-api?brand_id=${brandId}`;
            const res = await fetch(API);
            const json = await res.json();

            // Adjust this line based on actual response shape:
            const enabled = json && json?.is_enabled;
            const hasWhatsappRotation = typeof json?.is_whatsapp_rotation !== 'undefined';

            setShowIcon(Boolean(enabled));

            //Here, I am adding a check to implement the chat feature on this icon.
            if (hasWhatsappRotation) {
                const chatstate = enabled && !json?.is_whatsapp_rotation;
                setOpenChat(chatstate)
            }

        } catch (err) {
            console.error(`getAgentWhatsappApi: ${err}`);
        }
    }

    //Adding some changes to the current functionality
    const fetchWhatsAppInfo = (callback?: any) => {
        if (whatsAppData.phoneNumber) {
            let link = `https://wa.me/${(whatsAppData.phoneNumber || "").trim()}?text=${whatsAppData.message}`;
            window.location.href = link;
            if (callback && typeof callback == 'function') {
                callback();
            }
        }
        else {
            getWhatsAppInfo(brandId).then((res) => {
                const { data = {} } = res.data || {}
                setWhatsAppData(data);
                let link = `https://wa.me/${(data.phoneNumber || "").trim()}?text=${data.message}`;
                window.location.href = link;
                if (callback && typeof callback == 'function') {
                    callback();
                }
            }).catch((err) => {
                console.error(err)
            })
        }
    }


    const closeTooltip = () => {
        setTooltipState(false)
    }

    const openChatBot = async () => {
        if (!showChat100Provider) return;

        const chat100Data = {
            siteId: chat100SiteId,
            codePlan: chat100IdBeforeLogin
        };

        try {
            await chat100.open(chat100Data);
        } catch (error: any) {
            console.error("Chat100 open failed:", error);
        }
    }

    // const url = '/static/cashsite/brand/6/icon/watsapNewIcon.png'
    // const urlRedStyledicon='/static/cashsite/brand/6/icon/watsapNewIconRedShadow.png'
  
    return (
        <>
         {showIcon && showWhatsAppBeforeLogin && openChat &&(
                <WhatsAppWrapper rightSpace={props.rightSpace}>
                    {!token && tooltipState && (
                        <WhatsAppTooltip rightSpace={props.rightSpace}>
                        <TooltipCross onClick={closeTooltip}><span>x</span></TooltipCross>
                            <WhatsAppTooltipText onClick={openChatBot}>
                            <h6><Intl langKey="Whatsapp@whatsappText" /></h6>
                            <p><Intl langKey="Whatsapp@whatsappTextsub" /></p>
                        </WhatsAppTooltipText>
                        </WhatsAppTooltip> 
                        )  
                        }

                        {!token && (
                        <span onClick={openChatBot}>
                            <Player
                            autoplay
                            loop
                            controls
                            src={`${config.imageV3NonOptHost}/static/cashsite/brand/6/icon/whatsappIcon.json`}
                            style={{ height: '50px', width: '50px' }}
                            ></Player>
                        </span>
                        )} 
                </WhatsAppWrapper>
        )}
        {showIcon && showWhatsAppBeforeLogin && !openChat && (
                <WhatsAppWrapper rightSpace={props.rightSpace}>
                    {!token && tooltipState && (
                        <WhatsAppTooltip rightSpace={props.rightSpace}>
                        <TooltipCross onClick={closeTooltip}><span>x</span></TooltipCross>
                            <WhatsAppTooltipText onClick={() => fetchWhatsAppInfo(()=>CRMWhatsappClick(brandId))}>
                            <h6><Intl langKey="Whatsapp@whatsappText" /></h6>
                            <p><Intl langKey="Whatsapp@whatsappTextsub" /></p>
                        </WhatsAppTooltipText>
                        </WhatsAppTooltip> 
                        )  
                        }

                        {!token && (
                        <span onClick={() => fetchWhatsAppInfo(()=>CRMWhatsappClick(brandId))}>
                            <Player
                            autoplay
                            loop
                            controls
                            src={`${config.imageV3NonOptHost}/static/cashsite/brand/6/icon/whatsappIcon.json`}
                            style={{ height: '50px', width: '50px' }}
                            ></Player>
                        </span>
                        )} 
                </WhatsAppWrapper>
        )}

        <WhatsAppWrapper rightSpace={props.rightSpace}>
                {(brandId!== 39 && brandId!== 47) && token && showWhatsAppAfterLogin && (
                        <span onClick={() => fetchWhatsAppInfo(()=>CRMWhatsappClick(brandId))}>
                            <Player
                                autoplay
                                loop
                                controls
                                src={`${config.imageV3NonOptHost}/static/cashsite/brand/6/icon/whatsappIcon.json`}
                                style={{ height: '50px', width: '50px' }}
                            ></Player>
                        </span>
                    )} 
        </WhatsAppWrapper> 
    </>
)}

export default withTheme(withAppContext(WhatsappIco));

const WhatsAppNewWrapper = styled.div`
// width:80px;
height:60px;
display: flex;
align-items: center;
justify-content: flex-end;
// animation:adjustWidth 10s linear 1s;
overflow:hidden;
span {
    cursor: pointer;
}
img {
    max-height:55px;
    max-width:220px;
    padding-right:10px
}

// @keyframes adjustWidth {
//     0% { width:420px;}
//     50% {width:auto}
//     90% { width:auto}
//     100% { width:80px; overflow:hidden}

// }
`;


const WhatsAppWrapper = styled.div<Pick<StyleProps, 'rightSpace'>>`
    position: fixed;
    bottom: 20px;
    right: ${(props) => (props.rightSpace ? props.rightSpace : "20px")};
    z-index: 999999;
    cursor: pointer;
    border-radius: 50px;

    :hover {
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }

    & img {
        width: 50px;
        height: 50px;
    }
    & a {
      z-index: 99;
    }
    &.rpos {
      bottom: 0px;
    right: 5px;
    }
`
export const WhatsAppTooltip = styled.div<Pick<StyleProps, 'rightSpace'>>`
      position: fixed;
      bottom: 40px;
      right: ${(props) => (props.rightSpace ? props.rightSpace : "20px")};
      cursor: pointer;
      background: linear-gradient(90deg, #1C1E23 13.28%, #363B41 103.91%);
      box-shadow: 0px 0px 9px #4ED565;
      width: auto;
      padding: 0px 20px 10px 20px;
      border-radius: 10px;
      min-width: 250px;
`
export const TooltipCross = styled.div`
  width: 100%;
  height: 15px;

  & span {
    position: absolute;
    right: 10px;
    font-size: 18px;
    color: #7DD221;
    font-weight: 400;   
    /* font-family : 'Roboto'; */
  }
`

export const WhatsAppTooltipText = styled.div`
    cursor: pointer;
   & h6 {
        font-size: 12px;
        font-weight: 400;
        color: white;
        /* font-family: 'Roboto'; */
        margin: 3px 0px;
        text-transform: capitalize;
        letter-spacing: 1px;
      }
      
      & p {
        /* font-family: 'Roboto'; */
        font-size: 10px;
        font-weight: 400;
        color: white;
        width: 70px;
        min-width: 70px;
        max-width: 85px;
        border-bottom: 1px solid #059602;
        margin: 3px 0px;
        text-transform: capitalize;
        font-style: italic;
      }
`